'use client'

import { useState } from 'react'
import Link from 'next/link'
import { useAuth } from '@clerk/nextjs'
import { Button, PageHeader, StripeTag, Text } from '@/design-system'
import { AuthModal } from '@/components/auth/AuthModal'
import { HeroCollage } from './HeroCollage'

type AuthMode = 'sign-in' | 'sign-up'

export function Hero() {
  const { isSignedIn } = useAuth()
  const [authModal, setAuthModal] = useState<AuthMode | null>(null)

  return (
    <section
      style={{
        padding: '72px 28px 56px',
        position: 'relative',
        overflow: 'hidden'
      }}>
      <div
        aria-hidden
        style={{
          position: 'absolute',
          top: -60,
          right: 300,
          fontFamily: 'var(--font-display)',
          fontSize: 380,
          fontWeight: 900,
          letterSpacing: '-0.08em',
          lineHeight: 0.8,
          color: 'transparent',
          WebkitTextStroke: '2px rgba(10,10,10,0.08)',
          transform: 'rotate(-6deg)',
          pointerEvents: 'none',
          userSelect: 'none',
          zIndex: 0
        }}>
        SNAP
      </div>

      <div
        className="st-hero-grid"
        style={{
          maxWidth: 1180,
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: '1.35fr 1fr',
          gap: 36,
          alignItems: 'start'
        }}>
        <div>
          <StripeTag variant="accent">New · v1 · 2026</StripeTag>

          <PageHeader
            eyebrow="File transfer · secure · zero fuss"
            title={
              <span>
                Send <i style={{ fontStyle: 'italic', fontWeight: 700 }}>big</i> files
              </span>
            }
            mark="In a snap"
            sub="Send, Receive, Resumable uploads, password protection, client proofing, custom branding"
            titleStyle={{
              fontSize: 'clamp(44px, 8vw, 108px)',
              fontWeight: 900,
              letterSpacing: '-0.04em',
              lineHeight: 0.95
            }}
          />

          <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', alignItems: 'center' }}>
            {isSignedIn ? (
              <Link href="/send" style={{ textDecoration: 'none' }}>
                <Button variant="primary" arrow="right">
                  Open dashboard
                </Button>
              </Link>
            ) : (
              <>
                <Link href="/sign-up" style={{ textDecoration: 'none' }}>
                  <Button variant="primary" arrow="right">
                    Start sending free
                  </Button>
                </Link>
                <Button onClick={() => setAuthModal('sign-in')}>Sign in</Button>
              </>
            )}
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 22 }}>
            <span
              style={{
                width: 8,
                height: 8,
                background: 'var(--accent)',
                border: 'var(--border-thin) solid var(--ink)'
              }}
            />
            <Text variant="tag" opacity={0.7}>
              Free plan: 3 GB per transfer · no credit card
            </Text>
          </div>
        </div>

        <div className="st-hero-collage">
          <HeroCollage />
        </div>
      </div>

      {authModal !== null && <AuthModal mode={authModal} onClose={() => setAuthModal(null)} />}
    </section>
  )
}
